import { createService } from "@/Services/BaseService";

const RoiAdminService = createService("api/RoiAdmin");

export function getRoiProcesses(databaseDisplayName) {
  return RoiAdminService.get(`/Processes?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}`);
}

export function getAvailableProcesses(databaseDisplayName) {
  return RoiAdminService.get(`/AvailableProcesses?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}`);
}

export function createRoiProcess(databaseDisplayName, dto) {
  return RoiAdminService.post(`/Process?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}`, dto);
}

export function updateRoiProcess(databaseDisplayName, processData) {
  return RoiAdminService.put(`/Process?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}`, processData);
}

export function getRoiQueues(databaseDisplayName) {
  return RoiAdminService.get(`/Queues?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}`);
}

export function getAvailableQueues(databaseDisplayName) {
  return RoiAdminService.get(`/AvailableQueues?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}`);
}

export function createRoiQueue(databaseDisplayName, dto) {
  return RoiAdminService.post(`/Queue?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}`, dto);
}

export function updateRoiQueue(databaseDisplayName, queueData) {
  return RoiAdminService.put(`/Queue?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}`, queueData);
}

export function deleteRoiProcess(databaseDisplayName, processName) {
  return RoiAdminService.delete(`/Process?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}&processName=${encodeURIComponent(processName)}`);
}

export function deleteRoiQueue(databaseDisplayName, queueName) {
  return RoiAdminService.delete(`/Queue?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}&queueName=${encodeURIComponent(queueName)}`);
}
